import styled from 'styled-components';

export const Container = styled.div`
  height: 56px;
  border-bottom: 1px solid ${({ theme }) => theme['border--muted']};
  padding: 16px;
`;
